export default class RiskByYearService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    return this.$http.get('/api/report/data_a_y_srisk',
      {
        params: {
          ...params
        }
      }).then(r => r.data);
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/serious-risk-by-year/serious-risk-by-year.service.js